import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Item } from "@gtmhub/plugins/components/plugin/plugin.component";
import { Plugin, PluginContext, UIPluginAttachPoint } from "@webapp/plugins/plugins.models";

@Injectable({
  providedIn: "any",
})
export class PluginStateService {
  private accessPoint$ = new Subject<UIPluginAttachPoint | string>();
  private context$ = new Subject<PluginContext | string>();
  private item$ = new Subject<Item>();
  private plugin$ = new Subject<Plugin>();

  public getAccessPoint$(): Observable<UIPluginAttachPoint | string> {
    return this.accessPoint$.asObservable();
  }

  public setAccessPoint(args: UIPluginAttachPoint | string): void {
    this.accessPoint$.next(args);
  }

  public getContext$(): Observable<PluginContext | string> {
    return this.context$.asObservable();
  }

  public setContext(args: PluginContext | string): void {
    this.context$.next(args);
  }

  public getItem$(): Observable<Item> {
    return this.item$.asObservable();
  }

  public setItem(args: Item): void {
    this.item$.next(args);
  }

  public getPlugin$(): Observable<Plugin> {
    return this.plugin$.asObservable();
  }

  public setPlugin(args: Plugin): void {
    this.plugin$.next(args);
  }
}
